import { Flex, Avatar, Button, Image, Modal, ModalBody, Text, Box, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, SimpleGrid, Alert, AlertIcon, Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerBody, VStack, Divider } from "@chakra-ui/react"
import { Trans, useTranslation } from "next-i18next"
import { TbEdit } from "react-icons/tb"
import {IoFootstepsSharp} from "react-icons/io5"
import { GiCupcake } from "react-icons/gi"
import { AuthenticationContext } from "@/app/context/authentication/authenticationContext"
import { useContext } from "react"
import { AllQuestModelConst } from "@/app/const/allQuestModelConst"
import { Global } from "@emotion/react"
import { GlobalDataContext } from "@/app/context/global/globalDataContext"
import { FaLock } from "react-icons/fa6"
import { useRouter } from "next/router"
import { buildGameUrl, buildQuestUrl } from "@/app/helpers/buildUrlHelper"
import { GlobalDataUserContext } from "@/app/context/global/globalDataUserContext"
import { UnblockedConst } from "@/app/const/unblockedConst"
import { truncate } from "lodash"

type Props = {
    isOpen: boolean
    onClose: ()=>void
}

export const SelectQuestDrawer = ({isOpen, onClose}:Props) => {

    const { t } = useTranslation();
    const router = useRouter();
    const {
        user,
        isAuthLoading,
        setShowLoginModal

    } = useContext(AuthenticationContext)

    const {
        language,
        categoryId
    }= useContext(GlobalDataContext)

    const {
        userState
    } = useContext(GlobalDataUserContext)

    const goToQuest=(id:string)=>{        
        router.push(buildQuestUrl(language, categoryId, id), undefined, { shallow: true }).then(()=>{
            onClose();
        })
    }

    const closeQuest=()=>{
        onClose()
        router.push(buildGameUrl(language, categoryId, undefined), undefined, { shallow: true }).then()
       
    }

    return (
        <>
            <Drawer placement={"bottom"} onClose={closeQuest} isOpen={isOpen}>
                <DrawerOverlay />
                <DrawerContent maxH="75%" px={3}>
                    <DrawerHeader px={0} py={2} textAlign={"center"}>{t("quest.title")}</DrawerHeader>
                    <DrawerBody  px={0} pb={10} pt={0}>
                        <p>{t("quest.description")}</p>                            
                        {!isAuthLoading && user && <VStack alignItems={"start"}>
                            <small>{t("quest.discoveryMode")}</small>
                            {AllQuestModelConst.map((quest, index)=>{
                                let allow=false
                                const dependOnId = quest.dependOn
                                    ? UnblockedConst.find((unblocked) => unblocked.name === quest.dependOn)?.id
                                    : null;
        
                                if (quest.dependOn && (!userState?.unblocked || !userState.unblocked.includes(dependOnId as string))) {
                                    allow = true;
                                }
                                if ( quest.private ) {
                                    return null;
                                }
                                return (
                                <Button 
                                    key={index} 
                                    onClick={()=>{!allow && goToQuest(quest.id)}}
                                    background={!allow?(quest.background??"#6c27b7!important"):"#f3f3f3"} 
                                    color={!allow?(quest.color??"white"):"#a3a3a3"}  
                                    w="full" 
                                    alignItems={"flex-start"} 
                                    p={3}>
                                    <Text textAlign="left" w="full"> {quest.name[language as "fr"|"en"|"de"|"nl"]}</Text> 
                                    {allow && <Flex pl={1}> <FaLock style={{marginLeft:2}}/></Flex>}
                                    {!allow && quest.icon && <Flex pl={1}>{quest.icon}</Flex>}
                                    {/*!quest.dependOn && <Flex pl={1}>{quest.price} <GiCupcake style={{marginLeft:2}}/></Flex>*/}               
                                </Button>)})}                
                            <Divider/>
                            <small>{t("quest.culturalMode")}</small>
                            <p style={{background:"#f3f3f3", padding:10, borderRadius: 5}}>{t("quest.noQuestAround")}.</p>
                        </VStack>}
                        {!isAuthLoading && !user && <Alert status="warning">
                            <AlertIcon />
                            <VStack>
                                <Text>{t("quest.mustBeConnected")}</Text>
                                <Button onClick={()=>{setShowLoginModal(true)}} colorScheme="orange" size="sm" mt={2}>{t("quest.login")}</Button> 
                            </VStack>
                            </Alert>}
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </>
    )
}